import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg viewBox='0 0 16 16' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M 5.854 8.333 L 7.284 8.333 L 7.284 6.333 L 8.715 6.333 L 8.715 8.333 L 10.146 8.333 L 10.146 4.902 L 8 3.471 L 5.854 4.902 L 5.854 8.333 Z M 7.343 15.025 L 8 15.599 L 8.657 15.025 C 10.29 13.598 11.638 12.085 12.609 10.594 C 13.581 9.066 14.154 7.558 14.154 6.339 C 14.154 4.614 13.49 2.988 12.402 1.812 C 11.254 0.692 9.666 0 8 0 C 6.332 0 4.746 0.692 3.598 1.812 C 2.51 2.988 1.845 4.614 1.845 6.339 C 1.845 7.558 2.419 9.066 3.391 10.593 C 4.361 12.085 5.71 13.598 7.343 15.025 Z M 8 14.06 C 6.389 12.578 5.302 11.397 4.344 9.938 C 3.39 8.522 3 7.415 3 6.339 C 3 4.734 3.43 3.642 4.453 2.621 C 5.482 1.595 6.519 1.17 8 1.17 C 9.48 1.17 10.518 1.595 11.547 2.621 C 12.57 3.642 13 4.734 13 6.339 C 13 7.415 12.61 8.522 11.656 9.938 C 10.698 11.397 9.611 12.578 8 14.06 Z'
      fill='currentColor'
    />
  </svg>,
  'HomePin',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
